import { isIOS, osVersion } from 'react-device-detect';

export const isIOSVersionBelow = (version: number): boolean => {
  if (typeof window === 'undefined' || !isIOS) return false;

  const numericVersion = parseFloat(osVersion);
  if (isNaN(numericVersion)) return true;

  return numericVersion < version;
};
